import React from 'react';
import '../styles/AboutVid.css';

const AboutVid = () => {
  return (
    <div className="aboutvid-container">
      <h2 className="aboutvid-title">Ride-share brings people together</h2>
      <div className="video-wrapper">
        <iframe
          className="aboutvid-iframe"
          src="https://www.youtube.com/embed/pfnc9kKzlzQ"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default AboutVid;
